const DateField = {
  defaultProps: {
    enableAccessibleFieldDOMStructure: false,
  },
};

export default DateField;
